import { CLIENT_SELECT } from "store/actionTypes";

export const selectClient = (id) => (dispatch) =>
    dispatch({
        type: CLIENT_SELECT,
        selection: { idClient: id },
    });
